// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"73619ecc0abfc43662fe","293":"01970cf86a4f94241b74","518":"fa1738b26ae39914f244","779":"f836bcc112f09aad468b"}[chunkId] + ".js";
};